<template>
  <div class="rounded-2xl px-5 py-4 bg-white/5 border border-white/10">
    <div class="flex items-center justify-between">
      <p class="text-sm text-gray-300">
        Pergunta <span class="text-white font-semibold">{{ current + 1 }}</span
        >/<span>{{ total }}</span>
      </p>

      <p class="text-xs text-gray-500">
        {{ answeredCount }}/{{ total }} respondidas
      </p>
    </div>

    <div class="mt-4 overflow-x-auto">
      <div class="min-w-max flex items-center gap-3 p-3">
        <section v-for="i in total" :key="i">
          <button
            type="button"
            class="relative flex items-center justify-center"
            @click="$emit('jump', i - 1)"
            :title="tooltip(i - 1)"
          >
            <span
              class="w-3 h-3 rounded-full transition"
              :class="dotClass(i - 1)"
            ></span>

            <span v-if="i !== total" class="w-8 h-px bg-white/10"></span>
          </button>
        </section>
      </div>
    </div>

    <div class="mt-3 flex items-center gap-4 text-xs text-gray-500 flex-wrap">
      <template v-if="responseMode === 'binary'">
        <div class="flex items-center gap-2">
          <span class="w-2.5 h-2.5 rounded-full bg-green-500"></span>
          <span>SIM</span>
        </div>

        <div class="flex items-center gap-2">
          <span class="w-2.5 h-2.5 rounded-full bg-red-500"></span>
          <span>NÃO</span>
        </div>
      </template>

      <template v-else>
        <div class="flex items-center gap-2">
          <span class="w-2.5 h-2.5 rounded-full bg-green-500"></span>
          <span>Respondida</span>
        </div>
      </template>

      <div class="flex items-center gap-2">
        <span class="w-2.5 h-2.5 rounded-full bg-white/20"></span>
        <span>Pendente</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  total: { type: Number, required: true },
  current: { type: Number, required: true },

  answers: {
    type: Array,
    required: true, // null | 0 | 1 | 1..5
  },

  responseMode: {
    type: String,
    default: "binary",
  },

  options: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["jump"]);

const answeredCount = computed(
  () => props.answers.filter((a) => a !== null && a !== undefined).length
);

function findOptionLabel(value) {
  const option = props.options.find((item) => item.value === value);
  return option?.label || null;
}

function dotClass(index) {
  const value = props.answers[index];
  const isCurrent = index === props.current;

  let base = "bg-white/20";

  if (props.responseMode === "binary") {
    if (value === 1) base = "bg-green-500";
    if (value === 0) base = "bg-red-500";
  } else if (value !== null && value !== undefined) {
    base = "bg-green-500";
  }

  if (isCurrent) return `${base} ring-4 ring-white/10`;
  return base;
}

function tooltip(index) {
  const value = props.answers[index];

  if (value === null || value === undefined) {
    return `Pergunta ${index + 1}: Pendente`;
  }

  if (props.responseMode === "binary") {
    return `Pergunta ${index + 1}: ${value === 1 ? "SIM" : "NÃO"}`;
  }

  return `Pergunta ${index + 1}: ${findOptionLabel(value) || `Opção ${value}`}`;
}
</script>
